import { render, staticRenderFns } from "./ClientServices.vue?vue&type=template&id=2a4bb890&"
import script from "./ClientServices.vue?vue&type=script&lang=js&"
export * from "./ClientServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a4bb890')) {
      api.createRecord('2a4bb890', component.options)
    } else {
      api.reload('2a4bb890', component.options)
    }
    module.hot.accept("./ClientServices.vue?vue&type=template&id=2a4bb890&", function () {
      api.rerender('2a4bb890', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Components/ClientServices.vue"
export default component.exports